import React from 'react';
import classnames from 'classnames';
import { MenuItemGroup } from '../../../../Menu';
import { renderMenuOption } from '../StandardMenuOption';
import s from './StandardMenuGroup.scss';
// TODO: this export is terrible and is only needed because Menu is awful
export function renderStandardMenuGroup(_a, key) {
    var _b = _a.item, groupClassName = _b.className, label = _b.label, disabled = _b.disabled, items = _b.items, className = _a.className, itemClassName = _a.itemClassName, hideCheckIcon = _a.hideCheckIcon, withHoverEffect = _a.withHoverEffect;
    return (React.createElement(MenuItemGroup, { key: key, className: classnames(s['menu-group'], groupClassName, className), label: label, disabled: disabled }, items.map(function (item, idx) {
        return renderMenuOption({ item: item, className: itemClassName, hideCheckIcon: hideCheckIcon, withHoverEffect: withHoverEffect }, item.value || "item_" + idx);
    }
    /* TODO: refactor Menu so it's not awful
    <StandardMenuOption
      key={item.value || `item_${idx}`}
      item={item}
      className={itemClassName}
      hideCheckIcon={hideCheckIcon}
      withHoverEffect={withHoverEffect}
    /> */
    )));
}
var StandardMenuGroup = function (props) {
    return renderStandardMenuGroup(props);
};
StandardMenuGroup.displayName = 'StandardMenuGroup';
export default StandardMenuGroup;
//# sourceMappingURL=StandardMenuGroup.js.map